import { createSelector } from 'reselect';
import { keys } from 'lodash';
import {
  buildsByTypesAndProducts,
  latestReleaseBuildByProducts,
} from '../reducers';
import { build as constants } from './../helpers';

export const getRCBuildsByProducts = createSelector(
  buildsByTypesAndProducts,
  (buildsByTypesAndProducts) => {
    const prodBuildsByProducts = buildsByTypesAndProducts[constants.BUILD_PRODUCTION] ?
      buildsByTypesAndProducts[constants.BUILD_PRODUCTION] : {};
    const releasedBuildsByProducts = buildsByTypesAndProducts[constants.BUILD_RELEASE] ?
      buildsByTypesAndProducts[constants.BUILD_RELEASE] : {};
    const buildsByProducts = { ...prodBuildsByProducts, ...releasedBuildsByProducts };
    const builds = keys(buildsByProducts).reduce(
      (result, product) => {
        const rcbuildsByProduct = buildsByProducts[product].filter(b => b.is_rc);
        result[product] = rcbuildsByProduct;
        return result;
      }, {});
    return builds;
  }
);

export const getRCBuildsSinceLastReleaseByProducts = createSelector(
  getRCBuildsByProducts,
  latestReleaseBuildByProducts,
  (rcBuildsByProducts, releaseBuildsByProducts) => {
    const builds = keys(rcBuildsByProducts).reduce((result, product) => {
      const latestReleaseByProduct = releaseBuildsByProducts &&
       releaseBuildsByProducts[product] ?
        releaseBuildsByProducts[product] : {};
      const rcBuildsSinceLastReleaseByProduct =
       rcBuildsByProducts[product].filter(b => latestReleaseByProduct.build ?
         b.build >= latestReleaseByProduct.build : true);
      result[product] = rcBuildsSinceLastReleaseByProduct;
      return result;
    }, {});
    return builds;
  }
);


// WEBPACK FOOTER //
// src/selectors/build.js